import { render, staticRenderFns } from "./PricingBandAssignBusinessPortal.vue?vue&type=template&id=b21565c4&scoped=true&"
import script from "./PricingBandAssignBusinessPortal.vue?vue&type=script&lang=js&"
export * from "./PricingBandAssignBusinessPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21565c4",
  null
  
)

export default component.exports